import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const CURRENCY_SYMBOLS: Record<string, string> = {
  USD: '$', ILS: '₪', EUR: '€', GBP: '£', CAD: 'C$', AUD: 'A$',
};

export function getCurrencySymbol(code = 'USD'): string {
  return CURRENCY_SYMBOLS[code] || code;
}

export function formatPrice(amount: number, currencyCode = 'USD'): string {
  const locale = currencyCode === 'ILS' ? 'he-IL' : currencyCode === 'EUR' ? 'de-DE' : 'en-US';
  return new Intl.NumberFormat(locale, {
    style: 'currency', currency: currencyCode,
    minimumFractionDigits: 0, maximumFractionDigits: 2,
  }).format(amount);
}
